var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileHolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7812 9.84375C10.7812 12.1697 12.6741 14.0625 15 14.0625C17.3259 14.0625 19.2188 12.1697 19.2188 9.84375C19.2188 7.51781 17.3259 5.625 15 5.625C12.6741 5.625 10.7812 7.51781 10.7812 9.84375ZM22.5 23.4375H23.4375V22.5C23.4375 18.8822 20.4928 15.9375 16.875 15.9375H13.125C9.50625 15.9375 6.5625 18.8822 6.5625 22.5V23.4375H22.5Z",
    fill: "#005DAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileHolder);
export default __webpack_public_path__ + "static/media/profile-holder.0e16a18ae7817782896aa41722929c12.svg";
export { ForwardRef as ReactComponent };